/**
 * Route for `empty-states-with-cta`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EmptyStatesWithCtaPage } from "../features/empty-states-with-cta/EmptyStatesWithCtaPage";

export const emptyStatesWithCtaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/empty-states-with-cta",
	component: EmptyStatesWithCtaPage,
});

export default emptyStatesWithCtaRoute;
